import React from 'react'

import MainLayout from '../../Layout/MainLayout'


const Favourite = () => {

    return (
        <MainLayout>
            <div>
                <h1 className="font-poppins font-bold text-large" >
                Your Favourite is here check back later
                </h1>
                <div className="underline" />
            </div>
        </MainLayout>
    )
}

export default Favourite